import SizeSubtitleWithTableModal from './SizeSubtitleWithTableModal'

const CHEST_SIZE_TABLE_DATA = {
  thead: [{ defaultValue: 'Spoke Top Size', value: 'Collar Size (inches)' }],
  tbody: [
    { defaultValue: 'XS', value: '14.5' },
    { defaultValue: 'S', value: '15' },
    { defaultValue: 'M', value: '16' },
    { defaultValue: 'M+', value: '16.5' },
    { defaultValue: 'L', value: '17' },
    { defaultValue: 'L+', value: '17.5' },
    { defaultValue: 'XL', value: '18' },
    { defaultValue: 'XXL', value: '19' },
    { defaultValue: 'XXXL', value: '20' }
  ]
} as const

type ChestSizeSubtitleWithModalProps = {
  modalOpen: boolean
  toggleModal: () => void
}

function ChestSizeSubtitleWithModal({
  modalOpen,
  toggleModal
}: ChestSizeSubtitleWithModalProps) {
  return (
    <SizeSubtitleWithTableModal
      modalOpen={modalOpen}
      toggleModal={toggleModal}
      sizeType="Size"
      tableData={CHEST_SIZE_TABLE_DATA}
      title="What about collar size?"
      byline="The Sharp Shirt is cut in our SPOKE top sizes but these correspond to the traditional collar sizes as shown below."
    />
  )
}

export default ChestSizeSubtitleWithModal
